import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  col: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%"
  },
  top: {
    justifyContent: "flex-start"
  },
  middle: {
    justifyContent: "center"
  },
  bottom: {
    justifyContent: "flex-end"
  },
  around: {
    justifyContent: "space-around",
    maxWidth: "100%"
  },
  between: {
    justifyContent: "space-between"
  },
  start: {
    alignItems: "flex-start"
  },
  center: {
    alignItems: "center"
  },
  end: {
    alignItems: "flex-end"
  }
});

const getStyleFuncs = classes => ({
  getHorizontal: props => {
    if (props.top) {
      return classes.top;
    } else if (props.middle) {
      return classes.middle;
    } else if (props.bottom) {
      return classes.bottom;
    } else if (props.around) {
      return classes.around;
    } else if (props.between) {
      return classes.between;
    }
    return classes.top;
  },
  getVertical: props => {
    if (props.start) {
      return classes.start;
    } else if (props.center) {
      return classes.center;
    } else if (props.end) {
      return classes.end;
    }
    return classes.start;
  }
});

const Col = ({ classes, children, ...rest }) => {
  const styler = getStyleFuncs(classes);
  const computedStyle = [
    classes.col,
    styler.getHorizontal(rest),
    styler.getVertical(rest)
  ].join(" ");
  return <div className={computedStyle}>{children}</div>;
};

Col.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  start: PropTypes.bool,
  center: PropTypes.bool,
  end: PropTypes.bool,
  around: PropTypes.bool,
  between: PropTypes.bool,
  top: PropTypes.bool,
  middle: PropTypes.bool,
  bottom: PropTypes.bool
};

export default injectSheet(styles)(Col);



// WEBPACK FOOTER //
// ./src/components/Grid/Col.jsx